var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconCollectionLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconCollection",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1242.353 677.647V1920H0V677.647h1242.353Zm-112.941 112.941H112.942v1016.47h1016.47V790.589Zm-790.588 338.824h564.705V1016.47H338.824v112.94Zm0 451.764h564.705v-112.94H338.824v112.94ZM1581.176 338.824v1242.352h-225.882v-112.94h112.941V451.764H451.765v112.94H338.824V338.825h1242.352Zm-790.475 903.529v112.941H338.824v-112.941H790.7ZM1920.034-.011v1242.353h-225.882V1129.4h112.94V112.93H790.623v112.94H677.681V-.01h1242.353Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconCollectionLine.glyphName = 'collection';
IconCollectionLine.variant = 'Line';
IconCollectionLine.displayName = 'IconCollectionLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconCollectionLine.propTypes = {
  ...SVGIcon.propTypes
};
IconCollectionLine.allowedProps = [...SVGIcon.allowedProps];
export default IconCollectionLine;
export { IconCollectionLine };